import {
    GET_TEAM_BY_ADMIN_REQUEST,
    GET_TEAM_BY_ADMIN_SUCCESS,
    GET_TEAM_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getTeamByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEAM_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_TEAM_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_TEAM_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getTeamByAdminReducer;
